import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'end',
      gap: theme.spacing(1),
    },
    submitButton: {
      padding: theme.spacing(1.5, 3),
    },
    errorMessage: {
      color: COLORS.error.default,
    },
  }),
  { name: 'SubmitButton' }
);
